// This is copied from member app, TODO share it in td-utils?

import _ from 'lodash';

function mapKeysDeep(obj, cb) {
  if (_.isUndefined(obj)) {
    throw new Error(`mapKeysDeep expects an object but got ${typeof obj}`);
  }

  obj = _.mapKeys(obj, cb);

  const res = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const val = obj[key];

      if (_.isArray(val)) {
        res[key] = _.map(val, item => mapKeysDeep(item, cb));
      } else if (_.isObject(val)) {
        res[key] = mapKeysDeep(val, cb);
      } else {
        res[key] = val;
      }
    }
  }

  return res;
}

function mapValuesDeep(obj, cb) {
  if (_.isUndefined(obj)) {
    throw new Error(`mapValuesDeep expects an object but got ${typeof obj}`);
  }

  if (_.isObject(obj)) {
    return _.extend({}, obj, _.mapValues(obj, (val, _key) => mapValuesDeep(val, cb)));
  }

  return cb(obj);
}

export {
  mapKeysDeep,
  mapValuesDeep
};
